import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, forwardRef } from "react";
import { Column, ColumnsGridContainer } from "./styles";
export var ColumnsGrid = forwardRef(function (_a, ref) {
    var columnCount = _a.columnCount, _b = _a.gap, gap = _b === void 0 ? "10px" : _b, children = _a.children, props = __rest(_a, ["columnCount", "gap", "children"]);
    var array = Array.from({ length: columnCount }, function (_) { return []; });
    Children.forEach(children, function (child, index) {
        var column = array[index % columnCount];
        if (Array.isArray(column)) {
            column.push(child);
        }
    });
    return (_jsx(ColumnsGridContainer, __assign({ ref: ref, gap: gap }, props, { children: array.map(function (column) {
            return _jsx(Column, { gap: gap, children: column });
        }) })));
});
//# sourceMappingURL=index.js.map